<template>
    <div class="bot-detail-right">
              <div class="right-center">
                <a-row style="display: flex; align-items: center" v-for="item in personList" :key="item.id">
                  <a-col :span="4">
                    <a-avatar v-if="item.avatar" :size="64" icon="user" :src="item.avatar" />
                    <a-avatar v-else :size="64" icon="user" :src="imgUrlpor" />
                  </a-col>
                  <a-col :span="20">
                    <p>
                      {{ item.relatedDeptName }} ·
                      {{
                        item.relatedPersonnelName.length > 7
                          ? item.relatedPersonnelName.substr(0, 7) + '...'
                          : item.relatedPersonnelName
                      }}
                    </p>
                    <p>
                      {{ personType(item.relatedPersonnelType, personTypeList) }}
                      <span>{{ item.createTime }}</span>
                    </p>
                  </a-col>
                </a-row>
              </div>
              <!-- 分页 -->

              <a-pagination
                style="text-align: right"
                v-if="personTotal"
                size="big"
                :showTotal="(total) => `共 ${total} 条`"
                :pageSize="aboutPerson.pageSize"
                :current="aboutPerson.pageNum"
                :total="personTotal"
                @change="personChange"
              />
              <div v-else>
                <no-data></no-data>
              </div>
            </div>
</template>

<script>
export default {
    props:{
        personList: {
            type:Array,
            default: () => []
        },
        personTypeList:{
            type: Array,
            default: () => []
        },
        personTotal: {
            type: [Number, String],
            default: 0
        },
        aboutPerson: {
            type: Object,
            default: () => ({})
        },
        total:{
            type: [Number, String],
            default: 0
        },
    },
    watch:{
        personList: {
            handler(){},
            deep: true,
            immediate: true
        },
        personTypeList:{
            handler(){},
            deep:true,
            immediate:true
        },
        aboutPerson: {
            handler(){},
            deep: true,
            immediate: true
        },
    },
    data(){
        return {
            imgUrlpor: require('@/assets/home-imgs/头像.svg'),
        }
    },
    methods:{
        // 获取相关人员类型
        personType (val, list) {
            if (!val) return
            for (const d of list) {
                if (d.dictValue == val) {
                return d.dictLabel
                }
            }
        },
        // 人员分页改变
        personChange(page, pageSize){
            this.$emit('personChange',page, pageSize)
        },
    }
}
</script>

<style lang="less" scoped>
.bot-detail-right {
        width: 48%;
        padding: 30px 0 0 30px;
        border-radius: 3px;
        border: 2px solid #f2f6fc;
        margin-right: 41px;
        position: relative;

        .right-center {
          width: 94%;
          margin: 0 auto;

          /deep/.ant-col-4 {
            & > img {
              width: 120px;
              height: 120px;
              border-radius: 120px;
            }
          }
          /deep/.ant-col-20 {
            & > p {
              &:nth-of-type(1) {
                font-size: 16px;
                color: black;
                font-weight: bold;
                margin-top: 20px;
              }
              &:nth-of-type(2) {
                font-size: 16px;
                color: black;

                & > span {
                  font-size: 14px;
                  font-weight: normal;
                  color: #c2c1bf;
                  margin-left: 20px;
                }
              }
            }
          }
        }
        .ant-pagination {
          position: absolute;
          right: 10px;
          bottom: 10px;
        }
      }
</style>